const OG_LOCALE_MAP: Record<string, string> = {
    en: 'en_GB',
    de: 'de_DE',
}

const SUPPORTED_LOCALES = Object.keys(OG_LOCALE_MAP)

type SeoProps = {
    title?: string
    sideName?: string
    description?: string
    image?: {
        src: string
        width: number
        height: number
    }
    keywords?: string
    ogUrl?: string
    locale?: string
    ogType?: 'website' | 'product'
}

const seo = ({
    title,
    sideName = 'Gravity Shirts',
    description,
    keywords,
    image,
    ogUrl,
    locale,
    ogType = 'website',
}: SeoProps) => {
    const ogLocale = OG_LOCALE_MAP[locale ?? 'en'] ?? 'en_GB'
    const alternateLocales = SUPPORTED_LOCALES.filter((l) => l !== (locale ?? 'en')).map(
        (l) => OG_LOCALE_MAP[l]
    )

    return [
        {title: title ? `${title} | ${sideName}` : sideName},
        {name: 'description', content: description},
        {name: 'keywords', content: keywords},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description},
        {property: 'og:type', content: ogType},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:locale', content: ogLocale},
        ...alternateLocales.map((l) => ({property: 'og:locale:alternate', content: l})),
        ...(ogUrl ? [{property: 'og:url', content: ogUrl}] : []),
        ...(image
            ? [
                  {name: 'twitter:image', content: image.src},
                  {name: 'twitter:card', content: 'summary_large_image'},
                  {property: 'og:image', content: image.src},
                  {property: 'og:image:width', content: String(image.width)},
                  {property: 'og:image:height', content: String(image.height)},
              ]
            : []),
        ...(sideName ? [{property: 'og:site_name', content: sideName}] : []),
    ]
}

export default seo
